/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderModeEnum = "Limit_Order" | "Market_Order" | "%future added value";
export type OrderOrderType = "BUY" | "SELL" | "%future added value";
export type OrderTypeEnum = "Buy" | "Sell" | "%future added value";
export type CreateOrderMutationVariables = {|
  stockId: string,
  quantity: number,
  orderMode: OrderModeEnum,
  orderType: OrderTypeEnum,
  userPin: string,
  limitOrderPrice?: ?number,
|};
export type CreateOrderMutationResponse = {|
  +createOrder: ?{|
    +order: ?{|
      +id: string,
      +orderType: OrderOrderType,
    |},
    +message: ?string,
  |}
|};
export type CreateOrderMutation = {|
  variables: CreateOrderMutationVariables,
  response: CreateOrderMutationResponse,
|};
*/


/*
mutation CreateOrderMutation(
  $stockId: ID!
  $quantity: Float!
  $orderMode: OrderModeEnum!
  $orderType: OrderTypeEnum!
  $userPin: String!
  $limitOrderPrice: Float
) {
  createOrder(stockId: $stockId, quantity: $quantity, orderMode: $orderMode, orderType: $orderType, userPin: $userPin, limitOrderPrice: $limitOrderPrice) {
    order {
      id
      orderType
    }
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limitOrderPrice"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderMode"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "quantity"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stockId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userPin"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "limitOrderPrice",
        "variableName": "limitOrderPrice"
      },
      {
        "kind": "Variable",
        "name": "orderMode",
        "variableName": "orderMode"
      },
      {
        "kind": "Variable",
        "name": "orderType",
        "variableName": "orderType"
      },
      {
        "kind": "Variable",
        "name": "quantity",
        "variableName": "quantity"
      },
      {
        "kind": "Variable",
        "name": "stockId",
        "variableName": "stockId"
      },
      {
        "kind": "Variable",
        "name": "userPin",
        "variableName": "userPin"
      }
    ],
    "concreteType": "CreateOrder",
    "kind": "LinkedField",
    "name": "createOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrderNode",
        "kind": "LinkedField",
        "name": "order",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orderType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrderMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateOrderMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "d56fc65c77f52feb8be450125bcde887",
    "id": null,
    "metadata": {},
    "name": "CreateOrderMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrderMutation(\n  $stockId: ID!\n  $quantity: Float!\n  $orderMode: OrderModeEnum!\n  $orderType: OrderTypeEnum!\n  $userPin: String!\n  $limitOrderPrice: Float\n) {\n  createOrder(stockId: $stockId, quantity: $quantity, orderMode: $orderMode, orderType: $orderType, userPin: $userPin, limitOrderPrice: $limitOrderPrice) {\n    order {\n      id\n      orderType\n    }\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '19c892b391c701bc0bdc996bc347c48c';

module.exports = node;
